import { Checkbox } from "antd";
import { FC } from "react";
import { MarketWithoutRoute } from "tm-shared/types";

import { MarketCard } from "@/components/MarketCard";

import { StyledMarketCardSelectable } from "./Styled";

interface MarketCardSelectableProps {
    checked: boolean;
    toggleChecked: () => void;
    market: MarketWithoutRoute;
}

export const MarketCardSelectable: FC<MarketCardSelectableProps> = ({
    checked,
    toggleChecked,
    market,
}) => {
    return (
        <StyledMarketCardSelectable
            justify="flex-start"
            gap={12}
            align="flex-start"
        >
            <Checkbox
                checked={checked}
                onChange={toggleChecked}
                id={market.id}
            />

            <label htmlFor={market.id}>
                <MarketCard
                    address={market.address?.name || "-"}
                    fop={market.contragent?.name || "-"}
                />
            </label>
        </StyledMarketCardSelectable>
    );
};
